export { default } from './dropRight'
